import _define_property from "@swc/helpers/src/_define_property.mjs";
import { SpotifyHelpers } from "@spotify-internal/tracing-web";
// TODO: extract/centralize this so it's not buried in the platform and can be
// shared with other ownership initiatives.
var requestOwnership = new Map();
requestOwnership.set("activity-feed", {
    owner: "alohomora",
    tribe: "creator-core"
});
requestOwnership.set("canvaz-view", {
    owner: "imagine",
    tribe: "creator-studio"
});
requestOwnership.set("buyerxp-campaign-view", {
    owner: "buyer-experience",
    tribe: "creator-studio"
});
requestOwnership.set("creator-search-service", {
    owner: "bedrock-squad",
    tribe: "creator-core"
});
requestOwnership.set("hyperlink", {
    owner: "hype",
    tribe: "creator-studio"
});
requestOwnership.set("dm-best-friend-forever-service", {
    owner: "campfire",
    tribe: "creator-studio"
});
requestOwnership.set("bouncer", {
    owner: "hype",
    tribe: "creator-studio"
});
requestOwnership.set("marketplace-mgmt", {
    owner: "alohomora",
    tribe: "creator-core"
});
requestOwnership.set("marquee-assistant", {
    owner: "elevate-promo",
    tribe: "creator-studio"
});
requestOwnership.set("marquee-forecaster", {
    owner: "elevate-promo",
    tribe: "creator-studio"
});
requestOwnership.set("nms-form", {
    owner: "s4a-stardust",
    tribe: "s4x"
});
requestOwnership.set("nms-form-data", {
    owner: "s4a-stardust",
    tribe: "s4x"
});
requestOwnership.set("nms-submission", {
    owner: "s4a-stardust",
    tribe: "s4x"
});
requestOwnership.set("roster-view-service", {
    owner: "s4a-stardust",
    tribe: "s4x"
});
requestOwnership.set("s4a-onboarding", {
    owner: "alohomora",
    tribe: "creator-core"
});
requestOwnership.set("s4a-service", {
    owner: "bedrock-squad",
    tribe: "creator-core"
});
requestOwnership.set("s4x-access", {
    owner: "imagine",
    tribe: "creator-studio"
});
requestOwnership.set("s4x-home-service", {
    owner: "hanabi",
    tribe: "s4x"
});
requestOwnership.set("s4x-insights-api", {
    owner: "s4x-understand",
    tribe: "s4x"
});
requestOwnership.set("s4x-me", {
    owner: "bedrock-squad",
    tribe: "creator-core"
});
requestOwnership.set("s4x-wallet", {
    owner: "s4x-moneybadger",
    tribe: "creator-core"
});
requestOwnership.set("sponcerts", {
    owner: "s4a-stardust",
    tribe: "s4x"
});
requestOwnership.set("team-account-settings", {
    owner: "s4x-moneybadger",
    tribe: "creator-core"
});
requestOwnership.set("upcoming-view-service", {
    owner: "s4a-stardust",
    tribe: "s4x"
});
requestOwnership.set("romaine-stats-view", {
    owner: "s4a-stardust",
    tribe: "s4x"
});
requestOwnership.set("creator-payment-gateway", {
    owner: "s4x-moneybadger",
    tribe: "creator-core"
});
var OWNERSHIP_OWNER_TAG = "ownership.owner";
var OWNERSHIP_TRIBE_TAG = "ownership.tribe";
export function addOwnershipInfo(span, req) {
    var wgInfo = SpotifyHelpers.extractWebgateInfo(req);
    if (!wgInfo) return;
    var ownership = requestOwnership.get(wgInfo.service);
    if (!ownership) {
        if ("production" !== "production") {
            // eslint-disable-next-line no-console
            console.warn("Request to service ".concat(wgInfo.service, " did not have tracing ownership information registered."));
        }
        var _obj;
        span.addTags((_obj = {}, _define_property(_obj, OWNERSHIP_OWNER_TAG, "unknown"), _define_property(_obj, OWNERSHIP_TRIBE_TAG, "unknown"), _obj));
        return;
    }
    var _obj1;
    span.addTags((_obj1 = {}, _define_property(_obj1, OWNERSHIP_OWNER_TAG, ownership.owner), _define_property(_obj1, OWNERSHIP_TRIBE_TAG, ownership.tribe), _obj1));
}
